import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      private: true,
      text: 'Inicio',
    },
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { path: '/simulations' }
    },
  },
  {
    path: '/tracing',
    name: 'TracingView',
    meta: {
      private: true,
      text: 'Seguimiento',
    },
    component: () => import('../views/TracingView.vue'),
  },
  {
    path: '/simulations',
    name: 'SimulationsView',
    meta: {
      private: true,
      text: 'Simulaciones',
    },
    component: () => import('../views/SimulationsView.vue'),
  },
  {
    path: '/GeneralParameterization',
    name: 'GeneralParameterizationView',
    meta: {
      private: false,
      text: 'Parametrización general',
    },
    component: () => import('../views/GeneralParameterizationView.vue'),
  },
  {
    path: '/HvoExports',
    name: 'HvoExportsView',
    meta: {
      private: false,
      text: 'Exportaciones HVO',
    },
    component: () => import('../views/HvoExportsView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { path: '/simulations' }
    },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
